import { render, staticRenderFns } from "./MinBasketValue.vue?vue&type=template&id=62e75c65&"
import script from "./MinBasketValue.vue?vue&type=script&lang=js&"
export * from "./MinBasketValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentySyncs/51881/189/Woerner/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62e75c65')) {
      api.createRecord('62e75c65', component.options)
    } else {
      api.reload('62e75c65', component.options)
    }
    module.hot.accept("./MinBasketValue.vue?vue&type=template&id=62e75c65&", function () {
      api.rerender('62e75c65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/global/MinBasketValue.vue"
export default component.exports